import { IFilterOptions } from '@quadminds/shared/commons';
import { TachographDriverStatus } from '../enums';

// Complete tachograph data input with all filters and query options
export interface IGetTachographDataInputDto extends Pick<IFilterOptions, 'page' | 'limit' | 'sort' | 'populate'> {
    cardId?: string;
    cardIds?: string[];
    deviceIds?: number[];
    deviceCode?: string;
    deviceCodes?: string[];
    driverStatus?: TachographDriverStatus;
    from?: string;
    to?: string;
}

// Tachograph data by card ID with subset of filters and query options
export interface IGetTachographDataByCardIdInputDto
    extends Pick<IFilterOptions, 'page' | 'limit' | 'sort' | 'populate'> {
    deviceCode?: string;
    deviceCodes?: string[];
    from?: string;
    to?: string;
}

// Last tachograph report input with minimal filter set (no query options)
export interface IGetLastTachographReportInputDto {
    cardIds?: string[];
    deviceIds?: number[];
    deviceCode?: string;
    deviceCodes?: string[];
}
